<template>
    <div class="le-tea-training">
        <div class="pc-top-nav">
            <div class="le-center-content clearfix">
                <div class="new-center-top fl">
                    <div class="new-top-nav" :style="{ background: 'url(' + imgs + ')' }">
                        <h1 class="new-top-title fl">T</h1>
                        <div class="fl" style="padding-left:4px;">
                            <p class="new-top-navtitle">师资培训</p>
                            <p class="new-top-ews">RAIN</p>
                        </div>
                    </div>
                    <div class="le-tab-switch">
                        <span v-for="(item, index) in tab" :key="index" @click="spClick(item)" class="sp-tab-click" :class="{ spActive: active == item }">{{ item }}
                            <i class="wl-icon-xiangyou fr"></i>
                        </span>
                    </div>
                </div>
                <div class="nav-top-hander fl clearfix">
                    <div class="new-center-listnav clearfix">
                        <h2>{{ active }}</h2>
                        <div class="new-center-path">
                            <div class="crumbs-text">
                                <i class="wl-icon-zhuye1"></i>
                                <span>当前位置：</span>
                                <span @click="goHome" style="cursor: pointer;">网站首页</span>
                                <span>></span>
                                <span>师资培训</span>
                            </div>
                        </div>
                    </div>

                    <!-- 培训站点 -->
                    <div class="tab-active-one" v-if="active == '培训站点'">
                        <div class="le-site-scatter">
                            <span v-for="(item, index) in province" :key="index" @click="siteScatter(item)" class="sp-click-scatter" :class="{ siteActive: siteActive == item }">{{ item }}</span>
                        </div>
                        <div class="le-search-input">
                            <el-input placeholder="请输入站点名称" v-model="siteName" class="input-with-select" size="small">
                                <el-button slot="append" icon="el-icon-search"></el-button>
                            </el-input>
                        </div>
                        <div class="le-site-list clearfix">
                            <div class="le-site-hover">
                                <div class="le-site-li">
                                    <img src="https://zhykt.oss-cn-shanghai.aliyuncs.com/66ykt/ori/d7vjaawoblrfleyrs3ricg/rGKHPZih2WyhsZ7i.png" alt="" />
                                    <div class="li-site-info">
                                        <h3 class="h3-school-name">显示学校名称显示学校名称</h3>
                                        <div class="contact-info clearfix">
                                            <span class="fl">联系人：李航 </span>
                                            <span class="fr">联系电话：18729387483</span>
                                        </div>
                                        <div class="contact-info clearfix">
                                            <span class="fl">地址：安徽省合肥市高新区创新产业园1栋2019室</span>
                                            <span class="fr sp-color" @click="Amap"> <i class="wl-icon-dingwei"></i> 查看地图</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="le-site-hover">
                                <div class="le-site-li">
                                    <img src="https://zhykt.oss-cn-shanghai.aliyuncs.com/66ykt/ori/d7vjaawoblrfleyrs3ricg/rGKHPZih2WyhsZ7i.png" alt="" />
                                    <div class="li-site-info">
                                        <h3 class="h3-school-name">显示学校名称显示学校名称</h3>
                                        <div class="contact-info clearfix">
                                            <span class="fl">联系人：李航 </span>
                                            <span class="fr">联系电话：18729387483</span>
                                        </div>
                                        <div class="contact-info clearfix">
                                            <span class="fl">地址：安徽省合肥市高新区创新产业园1栋2019室</span>
                                            <span class="fr sp-color"> <i class="wl-icon-dingwei"></i> 查看地图</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="le-site-hover">
                                <div class="le-site-li">
                                    <img src="https://zhykt.oss-cn-shanghai.aliyuncs.com/66ykt/ori/d7vjaawoblrfleyrs3ricg/rGKHPZih2WyhsZ7i.png" alt="" />
                                    <div class="li-site-info">
                                        <h3 class="h3-school-name">显示学校名称显示学校名称</h3>
                                        <div class="contact-info clearfix">
                                            <span class="fl">联系人：李航 </span>
                                            <span class="fr">联系电话：18729387483</span>
                                        </div>
                                        <div class="contact-info clearfix">
                                            <span class="fl">地址：安徽省合肥市高新区创新产业园1栋2019室</span>
                                            <span class="fr sp-color"> <i class="wl-icon-dingwei"></i> 查看地图</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="le-site-hover">
                                <div class="le-site-li">
                                    <img src="https://zhykt.oss-cn-shanghai.aliyuncs.com/66ykt/ori/d7vjaawoblrfleyrs3ricg/rGKHPZih2WyhsZ7i.png" alt="" />
                                    <div class="li-site-info">
                                        <h3 class="h3-school-name">显示学校名称显示学校名称</h3>
                                        <div class="contact-info clearfix">
                                            <span class="fl">联系人：李航 </span>
                                            <span class="fr">联系电话：18729387483</span>
                                        </div>
                                        <div class="contact-info clearfix">
                                            <span class="fl">地址：安徽省合肥市高新区创新产业园1栋2019室</span>
                                            <span class="fr sp-color"> <i class="wl-icon-dingwei"></i> 查看地图</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            

                        </div>
                        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4" :page-sizes="[100, 200, 300, 400]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"> </el-pagination>
                    </div>
                    <!-- 核心专家 -->
                    <div class="tab-active-two" v-if="active == '核心专家'">
                        <div class="le-search-input">
                            <el-input placeholder="请输入专家名称" v-model="expertName" class="input-with-select" size="small">
                                <el-button slot="append" icon="el-icon-search"></el-button>
                            </el-input>
                        </div>
                        <div class="le-expert-list clearfix">
                            <div class="le-expert-li">
                                <div class="expert-hover">
                                    <div class="expert-li-info clearfix">
                                        <img :src="avatarImg" alt="" class="fl avatar-img" />
                                        <div class="expert-info fl">
                                            <p class="p-expert-name">专家名称</p>
                                            <p>职位：XXXX公司董事长</p>
                                        </div>
                                    </div>
                                    <div class="expert-li-profiles">
                                        简介：王毅表示，法国一直是维护多边主义，捍卫自由贸易贸易的重要力量，我们对法方为此作出的各种努力予以高度评价和赞赏。发展中国家的正当作出的各种努力予以高度评价和赞赏作出的各种努力予以高赏...
                                    </div>
                                </div>
                            </div>
                            <div class="le-expert-li">
                                <div class="expert-hover">
                                    <div class="expert-li-info clearfix">
                                        <img :src="avatarImg" alt="" class="fl avatar-img" />
                                        <div class="expert-info fl">
                                            <p class="p-expert-name">专家名称</p>
                                            <p>职位：XXXX公司董事长</p>
                                        </div>
                                    </div>
                                    <div class="expert-li-profiles">
                                        简介：王毅表示，法国一直是维护多边主义，捍卫自由贸易贸易的重要力量，我们对法方为此作出的各种努力予以高度评价和赞赏。发展中国家的正当作出的各种努力予以高度评价和赞赏作出的各种努力予以高赏...
                                    </div>
                                </div>
                            </div>
                            <div class="le-expert-li">
                                <div class="expert-hover">
                                    <div class="expert-li-info clearfix">
                                        <img :src="avatarImg" alt="" class="fl avatar-img" />
                                        <div class="expert-info fl">
                                            <p class="p-expert-name">专家名称</p>
                                            <p>职位：XXXX公司董事长</p>
                                        </div>
                                    </div>
                                    <div class="expert-li-profiles">
                                        简介：王毅表示，法国一直是维护多边主义，捍卫自由贸易贸易的重要力量，我们对法方为此作出的各种努力予以高度评价和赞赏。发展中国家的正当作出的各种努力予以高度评价和赞赏作出的各种努力予以高赏...
                                    </div>
                                </div>
                            </div>
                            <div class="le-expert-li">
                                <div class="expert-hover">
                                    <div class="expert-li-info clearfix">
                                        <img :src="avatarImg" alt="" class="fl avatar-img" />
                                        <div class="expert-info fl">
                                            <p class="p-expert-name">专家名称</p>
                                            <p>职位：XXXX公司董事长</p>
                                        </div>
                                    </div>
                                    <div class="expert-li-profiles">
                                        简介：王毅表示，法国一直是维护多边主义，捍卫自由贸易贸易的重要力量，我们对法方为此作出的各种努力予以高度评价和赞赏。发展中国家的正当作出的各种努力予以高度评价和赞赏作出的各种努力予以高赏...
                                    </div>
                                </div>
                            </div>
                        </div>
                        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4" :page-sizes="[100, 200, 300, 400]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"> </el-pagination>
                    </div>
                    <!-- 教学平台 -->
                    <div class="tab-active-three" v-if="active == '教学平台'">
                        <h3 class="h3-title-top">教学平台培训学习</h3>
                        <p class="p-text-center">
                            点击上方的教学平台按钮，进入物流云课堂，学校选择北京中物联物流采购培训中心，使用<span>培训报名时的帐号登录</span>，在<span>“我的学习”</span>中点击北京中物联物流采购培训中心院校，进入选择对应的课程进行学习。
                        </p>
                        <div class="guide-step-img">
                            <img :src="buzhou" alt="" />
                            <div class="step-bottom-text">
                                <span>登录物流云课堂</span>
                                <span style="text-align: center;">点击我的学习</span>
                                <span style="text-align: right;">学习培训课程</span>
                            </div>
                        </div>
                        <div class="btn-bottom">立即学习</div>
                    </div>
                    <!-- 会议报名 -->
                    <div class="tab-active-four" v-if="active == '会议报名'">
                        <!-- <meetSignUp></meetSignUp> -->
                    </div>
                </div>
            </div>
        </div>

        <!-- 手机端 -->
        <div class="ph-new-center-content">
            <div class="crumbs-text">
                <div style="padding:0 10px;">
                    <i style="color:#395782" class="wl-icon-zhuye1"></i>
                    <span @click="goHome" style="cursor: pointer;">首页</span>
                    <span>></span>
                    <span style="color:#395782">师资培训</span>
                </div>
            </div>
            <div class="le-tab-switch">
                <span v-for="(item, index) in tab" :key="index" @click="spClick(item)" class="sp-tab-click" :class="{ spActive: active == item }">{{ item }}</span>
            </div>
            <!-- 培训站点 -->
            <div class="tab-active-one" v-if="active == '培训站点'">
                <div class="le-site-scatter">
                    <span v-for="(item, index) in province" :key="index" @click="siteScatter(item)" class="sp-click-scatter" :class="{ siteActive: siteActive == item }">{{ item }}</span>
                </div>
                <div class="le-search-input">
                    <el-input placeholder="请输入站点名称" v-model="siteName" class="input-with-select" size="small">
                        <el-button slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                </div>
                <div class="le-site-list clearfix">
                    <div class="le-site-li">
                        <img src="https://zhykt.oss-cn-shanghai.aliyuncs.com/66ykt/ori/d7vjaawoblrfleyrs3ricg/rGKHPZih2WyhsZ7i.png" alt="" />
                        <div class="li-site-info">
                            <h3 class="h3-school-name">显示学校名称显示学校名称</h3>
                            <div class="contact-info clearfix">
                                <span class="fl">联系人：李航 </span>
                                <span class="fr">联系电话：18729387483</span>
                            </div>
                            <div class="contact-info clearfix">
                                <span class="fl">地址：安徽省合肥市高新区创新产业园1栋2019室</span>
                                <span class="fr sp-color"> <i class="wl-icon-dingwei"></i> 查看地图</span>
                            </div>
                        </div>
                    </div>
                    <div class="le-site-li">
                        <img src="https://zhykt.oss-cn-shanghai.aliyuncs.com/66ykt/ori/d7vjaawoblrfleyrs3ricg/rGKHPZih2WyhsZ7i.png" alt="" />
                        <div class="li-site-info">
                            <h3 class="h3-school-name">显示学校名称显示学校名称</h3>
                            <div class="contact-info clearfix">
                                <span class="fl">联系人：李航 </span>
                                <span class="fr">联系电话：18729387483</span>
                            </div>
                            <div class="contact-info clearfix">
                                <span class="fl">地址：安徽省合肥市高新区创新产业园1栋2019室</span>
                                <span class="fr sp-color"> <i class="wl-icon-dingwei"></i> 查看地图</span>
                            </div>
                        </div>
                    </div>
                    <div class="le-site-li">
                        <img src="https://zhykt.oss-cn-shanghai.aliyuncs.com/66ykt/ori/d7vjaawoblrfleyrs3ricg/rGKHPZih2WyhsZ7i.png" alt="" />
                        <div class="li-site-info">
                            <h3 class="h3-school-name">显示学校名称显示学校名称</h3>
                            <div class="contact-info clearfix">
                                <span class="fl">联系人：李航 </span>
                                <span class="fr">联系电话：18729387483</span>
                            </div>
                            <div class="contact-info clearfix">
                                <span class="fl">地址：安徽省合肥市高新区创新产业园1栋2019室</span>
                                <span class="fr sp-color"> <i class="wl-icon-dingwei"></i> 查看地图</span>
                            </div>
                        </div>
                    </div>
                    <div class="le-site-li">
                        <img src="https://zhykt.oss-cn-shanghai.aliyuncs.com/66ykt/ori/d7vjaawoblrfleyrs3ricg/rGKHPZih2WyhsZ7i.png" alt="" />
                        <div class="li-site-info">
                            <h3 class="h3-school-name">显示学校名称显示学校名称</h3>
                            <div class="contact-info clearfix">
                                <span class="fl">联系人：李航 </span>
                                <span class="fr">联系电话：18729387483</span>
                            </div>
                            <div class="contact-info clearfix">
                                <span class="fl">地址：安徽省合肥市高新区创新产业园1栋2019室</span>
                                <span class="fr sp-color"> <i class="wl-icon-dingwei"></i> 查看地图</span>
                            </div>
                        </div>
                    </div>
                </div>
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4" :page-sizes="[100, 200, 300, 400]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"> </el-pagination>
            </div>
            <!-- 核心专家 -->
            <div class="tab-active-two" v-if="active == '核心专家'">
                <div class="le-search-input">
                    <el-input placeholder="请输入专家名称" v-model="expertName" class="input-with-select" size="small">
                        <el-button slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                </div>
                <div class="le-expert-list clearfix">
                    <div class="le-expert-li">
                        <div class="expert-li-info clearfix">
                            <img :src="avatarImg" alt="" class="fl avatar-img" />
                            <div class="expert-info fl">
                                <p class="p-expert-name">专家名称</p>
                                <p>职位：XXXX公司董事长</p>
                            </div>
                        </div>
                        <div class="expert-li-profiles">
                            简介：王毅表示，法国一直是维护多边主义，捍卫自由贸易贸易的重要力量，我们对法方为此作出的各种努力予以高度评价和赞赏。发展中国家的正当作出的各种努力予以高度评价和赞赏作出的各种努力予以高赏...
                        </div>
                    </div>
                    <div class="le-expert-li">
                        <div class="expert-li-info clearfix">
                            <img :src="avatarImg" alt="" class="fl avatar-img" />
                            <div class="expert-info fl">
                                <p class="p-expert-name">专家名称</p>
                                <p>职位：XXXX公司董事长</p>
                            </div>
                        </div>
                        <div class="expert-li-profiles">
                            简介：王毅表示，法国一直是维护多边主义，捍卫自由贸易贸易的重要力量，我们对法方为此作出的各种努力予以高度评价和赞赏。发展中国家的正当作出的各种努力予以高度评价和赞赏作出的各种努力予以高赏...
                        </div>
                    </div>
                    <div class="le-expert-li">
                        <div class="expert-li-info clearfix">
                            <img :src="avatarImg" alt="" class="fl avatar-img" />
                            <div class="expert-info fl">
                                <p class="p-expert-name">专家名称</p>
                                <p>职位：XXXX公司董事长</p>
                            </div>
                        </div>
                        <div class="expert-li-profiles">
                            简介：王毅表示，法国一直是维护多边主义，捍卫自由贸易贸易的重要力量，我们对法方为此作出的各种努力予以高度评价和赞赏。发展中国家的正当作出的各种努力予以高度评价和赞赏作出的各种努力予以高赏...
                        </div>
                    </div>
                    <div class="le-expert-li">
                        <div class="expert-li-info clearfix">
                            <img :src="avatarImg" alt="" class="fl avatar-img" />
                            <div class="expert-info fl">
                                <p class="p-expert-name">专家名称</p>
                                <p>职位：XXXX公司董事长</p>
                            </div>
                        </div>
                        <div class="expert-li-profiles">
                            简介：王毅表示，法国一直是维护多边主义，捍卫自由贸易贸易的重要力量，我们对法方为此作出的各种努力予以高度评价和赞赏。发展中国家的正当作出的各种努力予以高度评价和赞赏作出的各种努力予以高赏...
                        </div>
                    </div>
                </div>
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4" :page-sizes="[100, 200, 300, 400]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"> </el-pagination>
            </div>
            <!-- 教学平台 -->
            <div class="tab-active-three" v-if="active == '教学平台'">
                <h3 class="h3-title-top">教学平台培训学习</h3>
                <p class="p-text-center">
                    点击上方的教学平台按钮，进入物流云课堂，学校选择北京中物联物流采购培训中心，使用<span>培训报名时的帐号登录</span>，在<span>“我的学习”</span>中点击北京中物联物流采购培训中心院校，进入选择对应的课程进行学习。
                </p>
                <div class="guide-step-img">
                    <img :src="buzhou" alt="" />
                    <div class="step-bottom-text">
                        <span>登录物流云课堂</span>
                        <span style="text-align: center;">点击我的学习</span>
                        <span style="text-align: right;">学习培训课程</span>
                    </div>
                </div>
                <div class="btn-bottom">立即学习</div>
            </div>
            <!-- 会议报名 -->
            <div class="tab-active-four" v-if="active == '会议报名'">
                <!-- <meetSignUp></meetSignUp> -->
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" width="700px">
            <el-amap ref="map" vid="amapDemo" :center="center" :zoom="zoom" class="amap-demo" v-if="dialogVisible">
                 <el-amap-info-window
                    :position="currentWindow.position"
                    :content="currentWindow.content"
                    :visible="currentWindow.visible"
                    :events="currentWindow.events">
                </el-amap-info-window>
            </el-amap>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
// import meetSignUp from "page/meet/meetSignUp.vue";
export default {
    // components: {
    //     meetSignUp,
    // },
    data() {
        return {
            zoom: 14, // 地图显示的缩放级别范围，在PC上，默认范围[3,18]，取值范围[3-18]；在移动设备上，默认范围[3-19]，取值范围[3-19]
            center: [117.134971,31.838124], // 地图中心点坐标值
            windows: [
                {
                    position: [117.134971,31.838124], // 信息窗体显示基点位置
                    content: '创新产业园C座!', // 显示内容。支持字符串和HTML
                    visible: true, // 信息窗体是否显示。这里需要注意的是，高德地图只支持同时一个信息窗体的显示。所以一旦有窗体显示切换的场景，visible数组的状态需要自行维护
                    events: { 
                        close() {
                            console.log('close infowindow1');
                        }
                    }
                },
            ],
            currentWindow: {
                position: [0, 0],
                content: '',
                events: {},
                visible: false
            },
            dialogVisible: false,
            imgs: require("../../assets/images/bg-training.png"),
            pageSize: 10,
            totalCount: 0,
            currentPage4: 10,
            tab: ["教学平台", "培训站点", "核心专家"],
            active: "教学平台",
            siteActive: "全部",
            siteName: "",
            expertName: "",
            province: ["全部", "北京", "天津", "上海", "重庆", "河北", "山西", "辽宁", "吉林", "黑龙江", "江苏", "浙江", "安徽", "福建", "江西", "山东", "河南", "湖北", "湖南", "广东", "海南", "四川", "贵州", "云南", "陕西", "甘肃", "青海", "内蒙自治区", "广西壮族自治区", "宁夏回族自治区"],
            avatarImg: require("assets/images/default_avatar3.png"),
            buzhou: require("assets/images/tea-buzhou.png"),
        };
    },
    mounted() {
        this.currentWindow = this.windows[0];
    },
    methods: {
        Amap() {
            this.dialogVisible = true;
        },
        //返回首页
        goHome() {
            this.$router.push({
                name: "xHome",
            });
        },
        spClick(index) {
            this.active = index;
        },
        siteScatter(item) {
            this.siteActive = item;
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.pageSize = val;
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
        },
    },
};
</script>

<style lang="scss">
.le-tea-training {
    .le-center-content {
        width: 1200px;
        margin: 0 auto;
    }
    .new-center-top {
        width: 220px;
        position: relative;
        margin-bottom: 70px;
        .new-top-nav {
            width: 220px;
            height: 78px;
            padding: 21px 0px;
            background: #2d82ff;
            .new-top-title {
                font-size: 58px;
                font-family: MicrosoftYaHei;
                font-weight: 400;
                color: #0155d1;
                margin-left: 23px;
                width: 48px;
            }
            .new-top-navtitle {
                padding-top: 16px;
                font-size: 18px;
                color: #fff;
            }
            .new-top-ews {
                padding-top: 8px;
                font-size: 14px;
                color: #0155d1;
                font-weight: bold;
            }
        }
        .new-center-tab {
            position: absolute;
            top: 140px;
            width: 220px;
            .new-center-dynamic {
                font-size: 16px;
                height: 38px;
                background: #e9ebf0;
                line-height: 40px;
                cursor: pointer;
                margin-bottom: 15px;
                padding: 0px 16px 0px 20px;
            }
            .class-back {
                background: #2d82ff;
                color: #fff;
            }
        }
    }
    .nav-top-hander{
        margin-left: 30px;
        width: calc(100% - 250px);
    }
    .new-center-listnav {
        margin-bottom: 30px;
        border-bottom: 2px solid #E9EBF0;
        height: 38px;
        line-height: 38px;
        h2 {
            font-size: 16px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            width: 80px;
            height: 100%;
            border-bottom: 2px solid #2D82FF;
            float: left;
        }
        .new-center-path {
            float: right;
            .wl-icon-zhuye1 {
                color: #A4A4A4;
                font-size: 16px;
            }
            span {
                margin-left: 7px;
                font-size: 14px;
                cursor: pointer;
            }
        }
    }
    .nav-crumb-top {
        margin-top: 23px;
    }
    .le-tab-switch {
        margin: 27px auto 0;
        .sp-tab-click {
            width: 220px;
            background: #E9EBF0;
            display: inline-block;
            padding: 0px 16px;
            color: #333;
            cursor: pointer;
            box-sizing: border-box;
            margin-bottom: 10px;
            font-size: 16px;
            line-height: 43px;
        }
        .spActive {
            background: #2D82FF;
            color: #fff;
        }
    }
    .tab-active-one {
        padding-bottom: 30px;
        border: 1px solid #E9EBF0;
        margin-bottom: 80px;
    }
    .le-site-scatter {
        // margin-top: 44px;
        width: 100%;
        background: rgba(255, 255, 255, 1);
        border-bottom: 1px solid #DFE2E6;
        padding: 15px 15px 5px 15px;
        box-sizing: border-box;
        .sp-click-scatter {
            padding: 3px 14px;
            color: #333333;
            font-size: 14px;
            margin: 0 5px 10px 5px;
            display: inline-block;
            border-radius: 14px;
            font-weight: bold;
            cursor: pointer;
        }
        .siteActive {
            color: #2D82FF;
            font-weight: bold;
        }
    }
    .le-search-input {
        text-align: right;
        padding-right: 25px;
        padding: 10px 25px 10px 10px;
        border-bottom: 1px solid #E9EBF0;
        box-sizing: border-box;
        .input-with-select {
            width: 240px;
            .el-input__inner {
                border-radius: 0;
            }
            .el-input-group__append,
            .el-input-group__prepend {
                border-radius: 0;
                background: #e9ebf0;
                color: #3168c4;
                font-size: 18px;
            }
        }
    }
    .le-site-list {
        margin-top: 30px;
        padding-bottom: 30px;
        padding: 0 20px;
        box-sizing: border-box;
        .le-site-hover{
            float: left;
            padding: 10px;
        }
        .le-site-li {
            width: 430px;
            border: 1px solid #f0f0f0;
            background: #fff;
            cursor: pointer;
            img {
                width: 100%;
                height: 180px;
            }
            .li-site-info {
                box-sizing: border-box;
                padding: 20px 22px;
            }
            .h3-school-name {
                font-size: 16px;
                color: #333333;
            }
            .contact-info {
                margin-top: 17px;
                color: #666666;
                font-size: 14px;
            }
            .sp-color {
                color: #1F36DE;
                font-weight: bold;
                font-size: 12px;
                i {
                    font-size: 14px;
                }
            }
        }
        .le-site-li:nth-child(2n) {
            margin-right: 0;
        }
        .le-site-hover:hover {
            background: #E9ECF0;
        }
    }
    .tab-active-two {
        padding-bottom: 35px;
        border: 1px solid #E9EBF0;
        margin-bottom: 40px;
    }
    .le-expert-list {
        margin-top: 34px;
        padding: 0 14px 30px 14px;
        .le-expert-li {
            width: 460px;
            float: left;
            box-sizing: border-box;
            padding: 15px;
        }
        .expert-hover{
            border: 1px solid #f0f0f0;
            padding: 22px;
            color: #666666;
            font-size: 14px;
            box-sizing: border-box;
            background: #fff;
        }
        .le-expert-li:nth-child(2n) {
            margin-right: 0;
        }
        .le-expert-li:hover {
            background: #E9ECF0;
        }
        .expert-info {
            margin: 17px 0 0 35px;
        }
        .p-expert-name {
            color: #333333;
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 10px;
        }
        .avatar-img {
            width: 76px;
            height: 76px;
            border-radius: 50%;
        }
        .expert-li-profiles {
            margin-top: 25px;
            line-height: 26px;
        }
    }
    .tab-active-three {
        background: #fff;
        margin-top: 65px;
        padding: 40px;
        box-sizing: border-box;
        margin-bottom: 80px;
        border: 1px solid #E9EBF0;
        .h3-title-top {
            position: relative;
            font-size: 18px;
            font-weight: bold;
            color: #333333;
            text-align: center;
        }
        .p-text-center {
            width: 779px;
            margin: 50px auto 0;
            font-size: 16px;
            line-height: 28px;
            color: #666666;
            text-indent: 35px;
            span {
                color: #2D82FF;
            }
        }
        .h3-title-top::before {
            content: "";
            position: absolute;
            width: 30px;
            height: 2px;
            background: #395782;
            border-radius: 1px;
            bottom: -10px;
            left: 48.68%;
        }
        .guide-step-img {
            width: 570px;
            margin: 80px auto 0;
            text-align: center;
        }
        .step-bottom-text {
            color: #666666;
            font-size: 16px;
            margin-top: 27px;
            span {
                display: inline-block;
                width: 33.33%;
                text-align: left;
            }
        }
        .btn-bottom {
            border-radius: 4px;
            font-size: 16px;
            background: #2D82FF;
            color: #fff;
            width: 100px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            margin: 145px auto 0;
            cursor: pointer;
        }
    }
    .tab-active-four {
        margin-top: 45px;
        padding-bottom: 80px;
    }
    .ph-new-center-content {
        display: none;
    }
    .amap-demo {
      height: 300px;
    }
}

@media only screen and (max-width: 800px) {
    .le-tea-training {
        .pc-top-nav {
            display: none;
        }
        .crumbs-text {
            background: #f5f7fa;
        }
        .ph-new-center-content {
            display: block;
            background: #fff;
        }
        .le-tab-switch {
            .sp-tab-click {
                width: 90px;
                font-size: 14px;
            }
        }
        .tab-active-three {
            margin-top: 40px;
            padding: 20px;
            border: none;
            .p-text-center {
                width: 100%;
                margin-top: 25px;
            }
            .guide-step-img {
                width: 100%;
                margin-top: 40px;
                img {
                    width: 90%;
                }
            }
            .step-bottom-text {
                font-size: 14px;
            }
            .btn-bottom {
                margin-top: 72px;
            }
        }
        .tab-active-four {
            margin-top: 25px;
        }
        .tab-active-one {
            margin: 10px;
            .le-site-scatter {
                margin-top: 10px;
                padding: 0;
            }
            .le-site-list {
                margin-top: 15px;
                padding: 0 10px;
                box-sizing: border-box;
                .le-site-li {
                    width: 100%;
                    margin-bottom: 15px;
                    img {
                        height: 130px;
                    }
                    .li-site-info {
                        padding: 10px 12px;
                    }
                    .contact-info {
                        margin-top: 10px;
                    }
                }
            }
        }
        .tab-active-two {
            margin: 10px;
            .le-search-input {
                padding-right: 10px;
            }
            .le-expert-list {
                margin-top: 18px;
                padding: 10px;
                .le-expert-li {
                    width: 100%;
                    padding: 15px 20px;
                    margin-bottom: 15px;
                    border: 1px solid #E9EBF0;
                }
                .avatar-img {
                    width: 60px;
                    height: 60px;
                }
                .expert-info {
                    margin: 9px 0 0 15px;
                }
                .expert-li-profiles {
                    margin-top: 22px;
                }
            }
        }
    }
}
</style>
